// Client HTTP pour /api/articles (public) et /api/admin/articles (admin).
const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';

  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const articlesApi = {
  // Public
  list:        (opts)        => request('/articles',                  { query: opts }),
  getBySlug:   (slug)        => request(`/articles/${encodeURIComponent(slug)}`),
  // Admin
  adminList:   (token, opts) => request('/admin/articles',            { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/articles/${id}`,      { token }),
  adminCreate: (token, body) => request('/admin/articles',            { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/articles/${id}`,      { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/articles/${id}`,      { method: 'DELETE', token }),
};
